module.exports = __webpack_public_path__ + "static/media/macos-gatekeeper-still-open.35d6b907.jpg";